import React from "react";
import RedefinicaoSenhaContainer from "./redefinicaosenha.container";

const RedefinicaoSenhaPage = props => {
  return <RedefinicaoSenhaContainer {...props}></RedefinicaoSenhaContainer>;
};

export default RedefinicaoSenhaPage;
